// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__B4raN","loading":"styles_loading__3ICo1"};